import Story from "./story";
import React from "react";
import Story2 from "./story2";
import MissionVision from "./missionVision";
import Opposites from "./oposites";

export default function AboutPage() {
  return (
    <div className="w-screen bg-neutral-900 z-30 flex flex-wrap mt-16 gap-20 justify-between w-screen">
      <img
        src="./header.jpeg"
        alt=""
        className="fixed top-0 left-0 w-full h-full opacity-10 "
      />

      <Story />
      <Opposites />
      <Story2 />
      {/* <Milestones /> */}
      <MissionVision />
      {/* <div className="flex justify-between w-full gap-10 p-40 z-50">
        {images.map((src, index) => (
          <div
            key={index}
            className={`relative transition-all duration-300 ease-in-out ${
              hoveredIndex === index
                ? "w-full skew-x-0"
                : "w-full skew-x-6"
            }`}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <img
              src={src}
              alt={`venue-${index + 1}`}
              className="w-full h-auto transition-all duration-300 ease-in-out"
            />
          </div>
        ))}
      </div> */}
    </div>
  );
}
